import './About.css';
import heroImage from '../../assets/hero-home-image.png';
import GetStartedSection from '../../components/GetStartedSection/GetStartedSection';
import ToolsSection from '../../components/ToolsSection/ToolsSection';
import PropertyAdvantage from '../../components/PropertyAdvantage/PropertyAdvantage';
import ConversationSection from '../../components/ConversationSection/ConversationSection';

const About = () => {
    return (
        <div className="about-page">





            {/* GET STARTED SECTION */}
            {/* GET STARTED SECTION */}
            <GetStartedSection />


            <section className="about-intro">
                <div className="about-wrapper">


                    {/* LEFT IMAGE */}
                    <div className="about-image">
                        <img src={heroImage} alt="Modern Building" />
                    </div>

                    {/* RIGHT CONTENT */}
                    <div className="about-content">

                        {/* BADGE */}
                        <span className="about-badge">Jeevan Realty</span>

                        {/* TITLE */}
                        <h2 className="about-title">
                            A new experience in real estate.
                        </h2>

                        {/* DESCRIPTION */}
                        <p className="about-text">
                            Our vision is to set the highest standards in the real estate market by helping you discover your dream property. Jeevan Realty is powered by a dynamic team of young professionals, recognized for our in-depth market knowledge and unwavering commitment to our customers.
                            We believe that delivering quality service is the foundation of strong relationships. By communicating transparently and effectively, we strive not only to build lasting connections with our clients but also to nurture and preserve them over time.
                        </p>

                        {/* CTA CARD */}
                        <div className="about-cta">
                            <h3>Schedule a Call</h3>
                            <p>
                                Helping you discover the perfect property that fits your needs.<br />
                                ➜
                            </p>
                        </div>

                    </div>

                </div>
            </section>













            <section className="about">
                <div className="about-wrapper">


                    {/* LEFT CONTENT */}
                    <div className="about-content">

                        {/* BADGE */}
                        <span className="about-badge">Our Mission</span>

                        {/* TITLE */}
                        <h2 className="about-title">
                            Real Estate with Purpose and Passion.
                        </h2>

                        {/* DESCRIPTION */}
                        <p className="about-text">
                            With a strong heritage of trust, Jeevan Realty is a pioneer in creating genuine value in properties and places. Founded in 2018, with our head office in Coimbatore,
                            we are a leading real estate solutions company operating across diverse cities in South India.
                            Our business is deeply customer-centric, powered by experienced service agents and modern technology.
                            We efficiently coordinate the purchase and sale of real estate—including
                            residential homes, townhouses, condominiums, new constructions, and land—tailored precisely to our clients’ needs.
                        </p>

                        {/* CTA CARD */}
                        <div className="about-cta">
                            <h3>Sell your Property</h3>
                            <p>
                                ➜
                            </p>
                        </div>

                    </div>

                    {/* RIGHT IMAGE */}
                    <div className="about-image">
                        <img src={heroImage} alt="Modern Building" />
                    </div>

                </div>
            </section>




            {/* TOOLS LOGOS SECTION */}
            <ToolsSection />











            <section className="about">
                <div className="about-wrapper">


                    {/* LEFT IMAGE */}
                    <div className="about-image">
                        <img src={heroImage} alt="Modern Building" />
                    </div>

                    {/* RIGHT CONTENT */}
                    <div className="about-content">

                        {/* BADGE */}
                        <span className="about-badge">Our Vision</span>

                        {/* TITLE */}
                        <h2 className="about-title">
                            Real Estate with Purpose and Passion.
                        </h2>

                        {/* DESCRIPTION */}
                        <p className="about-text">
                            Our vision is to set the highest standards in the real estate market by helping you discover your dream property. Jeevan Realty is powered by a dynamic team of young professionals, recognized for our in-depth market knowledge and unwavering commitment to our customers.
                            We believe that delivering quality service is the foundation of strong relationships. By communicating transparently and effectively, we strive not only to build lasting connections with our clients but also to nurture and preserve them over time.
                        </p>

                        {/* CTA CARD */}
                        <div className="about-cta">
                            <h3>Buy your Property</h3>
                            <p>
                                ➜
                            </p>
                        </div>

                    </div>

                </div>
            </section>


            <PropertyAdvantage />

            <ConversationSection />







        </div>
    );
};

export default About;
